import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    theme: null,
    token: null,
    userCars: []
  },
  getters: {
    getTheme: (state) => state.theme,
    getToken: (state) => state.token,
    getUserCars: (state) => state.userCars,
    getUserCar(state) {
      return (id) => {
        return state.userCars.find(car => car.id === id);
      }
    },
  },
  actions: {
    setTheme({ commit }, theme) {
      commit('setTheme', theme);
    },
    setToken({ commit }, token) {
      commit("setToken", token);
    },
    setUserCars({ commit }, userCars) {
      commit("setUserCars", userCars);
    },
  },
  mutations: {
    setTheme: (state, theme) => state.theme = theme,
    setToken: (state, token) => state.token = token,
    setUserCars: (state, userCars) => state.userCars = userCars,
  },
  modules: {
  }
})
